<template>
  <BContainer
    fluid
    class="px-0"
  >

    <BRow class="gap-y-5 mt-3">
      <BCol
        cols="12"
      >
        <h5 class="border-bottom py-2 font-weight-bold">
          <i class="fad fa-user-tie-hair" /> GROWERS
        </h5>
      </BCol>
      <BCol
        v-for="(fso, index) in fsOfficers.customers"
        :key="index"
        cols="12"
        md="4"
      >
        <BCard>
          <BCardTitle style="font-size: 15px; height: 30px; display: flex; align-items: center;">
            {{ fso.title }}
          </BCardTitle>
          <BCardBody
            class="p-1 d-flex justify-content-center align-items-center"
          >
            <VideoPlayer
              :src="getVideoSrc('customers', fso.src)"
              :options="{
                autoplay: false,
                controls: true
              }"
              class="border rounded-sm video-player"
            />
          </BCardBody>
        </BCard>
      </BCol>
    </BRow>

    <BRow class="gap-y-5 mt-5">
      <BCol
        cols="12"
      >
        <h5 class="border-bottom py-2 font-weight-bold">
          <i class="fad fa-list-check" /> TASKS
        </h5>
      </BCol>
      <BCol
        v-for="(fso, index) in fsOfficers.tasks"
        :key="index"
        cols="12"
        md="4"
      >
        <BCard>
          <BCardTitle style="font-size: 15px; height: 30px; display: flex; align-items: center;">
            {{ fso.title }}
          </BCardTitle>
          <BCardBody
            class="p-1 d-flex justify-content-center align-items-center"
          >
            <VideoPlayer
              :src="getVideoSrc('tasks', fso.src)"
              :options="{
                autoplay: false,
                controls: true
              }"
              class="border rounded-sm video-player"
            />
          </BCardBody>
        </BCard>
      </BCol>
    </BRow>

  </BContainer>
</template>
<script>
import VideoPlayer from '@/views/shared/documents/components/VideoPlayer.vue'

export default {
  name: 'SharedFSODocumentTutorials',

  components: {
    VideoPlayer
  },

  middleware: ['auth'],

  data () {
    return {
      fsOfficers: {
        customers: [
          {
            title: 'Create a New Customer',
            src: 'create-customer'
          },
          {
            title: 'Update Existing Customer',
            src: 'update-customer'
          },
          {
            title: 'Add Farms to Customer',
            src: 'add-customer-farm'
          },
          {
            title: 'Add Crop Histories to Customer',
            src: 'add-customer-crop-history'
          },
          {
            title: 'Add Documents to Customer',
            src: 'add-customer-document'
          },
          {
            title: 'Add Interactions to Customer',
            src: 'add-customer-interaction'
          }
        ],
        tasks: [
          {
            title: 'Create an Event for assigned Task',
            src: 'record-events-tasks'
          }
        ]
      }
    }
  },

  mounted () {
    // Code to run when the component is mounted
  },

  methods: {
    getVideoSrc (folder, videoName) {
      return `${window.location.origin}/videos/${folder}/${videoName}.mp4`
    }
  }
}
</script>
<style scoped>
.video-player {
  max-height: 220px;
  min-height: 220px;
  background-color: black;
  width: 100%;
}

@media  screen and (max-width: 1600px) {
  .video-player {
    max-height: 170px;
    min-height: 170px;
  }
}

@media screen and (max-width: 1200px) {
  .video-player {
    max-height: 95px;
    min-height: 95px;
  }
}

@media screen and (max-width: 516px) {
  .video-player {
    max-height: 170px;
    min-height: 170px;
  }
}
</style>
